import type { IUndoUpdateResponse } from '@/interfaces/IMenuImport';

/** The dynamic dialog of «¿Deshacer la actualización?» (plan §3.9). */
export const MENU_UPDATE_UNDO_MODAL = 'v2-menu-update-undo';

/** Emitted on `EventBus` once an update was undone (the items page reloads). */
export const MENU_UPDATE_UNDONE_EVENT = 'menu-update-undone';

/** How «Deshacer» of the dialog ended: undone, too late, or refused (toasted; the dialog stays). */
export type TUndoUpdateAttempt = IUndoUpdateResponse | 'expired' | 'failed';
